import { render, staticRenderFns } from "./csr_table.vue?vue&type=template&id=119578ba&scoped=true&"
import script from "./csr_table.vue?vue&type=script&lang=js&"
export * from "./csr_table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119578ba",
  null
  
)

export default component.exports